<script>
    /* Copyright (c) 2020-2022 Jacques Desodt */
    import {createEventDispatcher} from 'svelte';
    import {isAm} from '../scripts/dates.js';

    const dispatch = createEventDispatcher();

    export let args = {};
    export let date = new Date();

    /* Local variables */
    let amStyle;
    $: amStyle = isAm(date) ? 'color:' + args.color + ';' : '';
    let pmStyle;
    $: pmStyle = !isAm(date) ? 'color:' + args.color + ';' : '';
</script>

<div class="_tp-part" style={amStyle}
     on:click|stopPropagation={() => dispatch('am')}
>
    AM
</div>
<div class="_tp-part" style={pmStyle}
     on:click|stopPropagation={() => dispatch('pm')}
>
    PM
</div>

<style>._tp-part{color:hsla(0,0%,100%,.4);cursor:pointer;font-size:1.3rem;margin:.25rem;transition-duration:.3s;transition-property:background-color,border-color,color,fill,stroke}._tp-part:hover{background-color:rgba(0,0,0,.1)}</style>
